export default "__VITE_ASSET__0d61e455__"